import { METHODS } from '@system/acl/methods';
import type { UserInfo, matchesFn } from '@system/acl/types';

import { EAppRouteStatus } from '@utils/enums';

export function trailedDirectGroupMatch(
  matches: Map<string, matchesFn>,
  userInfo: UserInfo,
): void {
  /** =======================[ Редактирование группы вагонов ]====================== */
  matches.set(METHODS.carriageGroups.deleteTrailedDirectGroup, conditions =>
    conditions?.status === EAppRouteStatus.StatusPlanning && userInfo.isFpk
      ? true
      : !!conditions?.branchId && conditions.branchId === userInfo.branchId,
  );

  matches.set(
    METHODS.carriageGroups.createTrailedDirectGroup,
    conditions => conditions?.status === EAppRouteStatus.StatusPlanning,
  );
}
